import { tixApiClient } from "./tixApiClient.instance";

export const sendContactMessage = async (email: string, message: string, recaptcha?: string) => {
  const path = "/support/contact";
  const method = "POST";

  const headers = {
    ...(recaptcha && { recaptcha })
  };

  const data = {
    email,
    message
  };

  return await tixApiClient.sendRequest<any>({ url: path, method, headers, data });
};
